import ProductWishListHandler from 'PyzShopUi/scripts/product-wish-list/ProductWishListHandler';
import { mediaCenterProductImageLocator } from 'PyzShopUi/scripts/shop-ui/includes/product-image-locator';
import {IProductItem} from 'PyzShopUi/scripts/shop-ui/interfaces';

export const displayAbstractMediaCenterWishlistIcon = (): void => {
    const adpWrapper: HTMLElement = document.querySelector('.article-main-info');
    if (!adpWrapper) {
        return;
    }

    const wishlistIcon: HTMLElement = adpWrapper.querySelector('.product-wish-list-icon-container');
    wishlistIcon.dataset.type = 'product_abstract';
    wishlistIcon.dataset.sku = wishlistIcon.dataset.initialSku;
    wishlistIcon.dataset.etrackerProduct = wishlistIcon.dataset.etrackerProduct;

    ProductWishListHandler.renderIcons(adpWrapper, mediaCenterProductImageLocator);
}

export const displayConcreteMediaCenterWishlistIcon = (sku: string, eTrackerProduct: any): void => {
    const adpWrapper: HTMLElement = document.querySelector('.article-main-info');
    if (!adpWrapper) {
        return;
    }

    const wishlistIcon: HTMLElement = adpWrapper.querySelector('.product-wish-list-icon-container');
    wishlistIcon.dataset.type = 'product_concrete';
    wishlistIcon.dataset.sku = sku;
    wishlistIcon.dataset.etrackerProduct = JSON.stringify(eTrackerProduct)

    ProductWishListHandler.renderIcons(adpWrapper, mediaCenterProductImageLocator);
}
